import { Map } from 'immutable';
import { ResourcefulReducer } from '../../util';
import ACTIONS from '../actions';

const InmateReducer = new ResourcefulReducer('inmates', Map, {
  actionTypes: [ACTIONS.FETCH_INMATE.success, ACTIONS.UPDATE_INMATE.success, ACTIONS.CREATE_INMATE.success],
});

export default InmateReducer;
